import { api } from '@/api/index'
import { AxiosResponse } from 'axios';
const baseURL = '/api/home/'
// 获取 头部信息tab
export const channel = async (): Promise<AxiosResponse<any>> =>
  await api.get({ url: baseURL + 'channel/', queryParam: { parent_id: 1 } });
// 获取活动推荐
export const channelList = async (queryParam: any): Promise<AxiosResponse<any>> =>
  await api.get({ url: baseURL + 'channel/detail_list/', queryParam });
// 获取进行中的订单列表
export const OrderInProgressList = async (queryParam?: any): Promise<AxiosResponse<any>> =>
  await api.get({ url: baseURL + 'k3/production_order/', queryParam });

// 获取密码加密参数
export const getPasswordParameters = async (): Promise<AxiosResponse<any>> =>
  await api.get({ url: baseURL + 'login/check_old_password/' });
// 旧密码验证
export const checkOldPassword = async (data: any): Promise<AxiosResponse<any>> =>
  await api.post({ url: baseURL + 'login/check_old_password/', data });
// 修改密码
export const editPassword = async (data: any): Promise<AxiosResponse<any>> =>
  await api.post({ url: baseURL + 'login/modify_password/', data });
//上传头像
export const uploadAvatar = async (data: any): Promise<AxiosResponse<any>> =>
  await api.post({ url: baseURL + 'upload_file/', data });

// 获取个人信息
export const getUserInfo = async (): Promise<AxiosResponse<any>> =>
  await api.get({ url: baseURL + 'personal_information/' });

// 修改个人信息
export const editUserInfo = async (data: any): Promise<AxiosResponse<any>> =>
  await api.post({ url: baseURL + 'personal_information/', data});
// 获取 基因下载模板
export const channelDetail = async (id: number): Promise<AxiosResponse<any>> =>
await api.get({ url: baseURL + 'channel/'+ id + '/', });